<div class="mobile">
  <router-outlet></router-outlet>
</div>
